const theme: { [key: string]: string } = {
    darkGrey: '#5A5B5E',
    grey: '#999999',
    grey40: '#666666',
    lightBlue: '#03A9F4',
    lightGrey: '#CCCCCC',
    lightestGrey: '#F2F2F2',
    darkGreen: '#687A2B',
    ssgGreen: '#93AD3C',
    lightGreen: '#EFF3E2',
    darkJaundice: '#FFC441',
    jaundice: '#FFEBBD',
    orange: '#F47A35',
    mint: '#20907F',
    blue: '#67CAD9',
    darkBlue: '#03A9F4',
    darkerBlue: '#01579B',
    sherpaBlue: '#003D50',
    coral: '#EC5B49',
    red: '#CC0000',
    lightRed: '#F8D9D9',
    green: '#659530',
    white: '#FFFFFF',
    black: '#000000',
    greyOnYellow: '#9F7417',
    buttermilk: '#F9ECC8',
    mintLight: '#DEEFEC'
};

export default theme;
